import React from 'react'
import Popup from '../../../../components/ui/popup'
import { Trans, useTranslation } from 'react-i18next'
import Button from '../../../../components/ui/button'
import cls from './reportPopup.module.sass'
import FAQ from '../../../../components/ui/popup/FAQ'
import { postDenounce } from '../../../../api/ephemeral'

interface Props {
    onClose: () => void
    id: number
    setIsReported: React.Dispatch<React.SetStateAction<boolean>>
}

const ReportPopup = ({ onClose, id, setIsReported }: Props) => {
    const [t] = useTranslation()

    const [isLoading, setIsLoading] = React.useState(false)
    const [errorText, setErrorText] = React.useState('')

    const handleReport = async () => {
        setIsLoading(true)
        setErrorText('')
        const reportResponse = await postDenounce({ id })
        if (reportResponse.status === 'success') {
            setIsReported(true)
            setIsLoading(false)
            onClose()
        }
        if (reportResponse.status === 'error') {
            setIsLoading(false)
            setErrorText(reportResponse.message)
        }
    }
    return (
        <Popup title={t('Story not compliant')} onClose={onClose} classname={cls['popup']}>
            <div className={cls['reportPopup']}>
                <div>
                    <p>{t('report_1')}</p>
                    <p>{t('report_2')}</p>
                    <p>{t('report_3')}</p>
                    <p style={{ color: '#a23330', fontSize: '12px' }}>{errorText}</p>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button label={'Report'} disabled={isLoading} onClick={handleReport} />
                    <Button label={'Cancel'} secondary disabled={isLoading} onClick={onClose} />
                </div>
            </div>
        </Popup>
    )
}

export default ReportPopup
